import { ADMIN_ROUTES, CUSTOMER_ROUTES } from '~/constants/router'
import { STORE_TYPES } from '~/constants/store'
import {
  customerRolesEditable,
  customerRolesView,
  customerSendEmail,
} from '~/modules/auth/conditions'
import { lazyRetry } from '~/utils/lazyRetry'

const CustomerForm = lazyRetry(() => import('~/pages/Customer/'))
const CustomerList = lazyRetry(() => import('~/pages/Customer/'))
const CustomerDetail = lazyRetry(() => import('~/pages/Customer'))
const CovaCustomerForm = lazyRetry(
  () => import('~/pages/Customer/CovaCustomerForm'),
)
const CovaCustomerDetail = lazyRetry(
  () => import('~/pages/Customer/CovaCustomerDetail'),
)
const CovaCustomerList = lazyRetry(
  () => import('~/pages/Customer/CovaCustomerList'),
)
const GreenlineCustomerList = lazyRetry(
  () => import('~/pages/Customer/GreenlineCustomerList'),
)
const GreenlineCustomerDetail = lazyRetry(
  () => import('~/pages/Customer/GreenlineCustomerDetail'),
)
const ShopifyCustomerList = lazyRetry(
  () => import('~/pages/Customer/ShopifyCustomerList'),
)
const ShopifyCustomerDetail = lazyRetry(
  () => import('~/pages/Customer/ShopifyCustomerDetail'),
)
const SendEmail = lazyRetry(() => import('~/pages/Customer/SendEmail'))

const CovaCustomerListV2 = lazyRetry(
  () => import('~/pages/Customer/CovaCustomerListV2'),
)
const CovaCustomerDetailV2 = lazyRetry(
  () => import('~/pages/Customer/CovaCustomerDetailV2'),
)
const GreenlineCustomerListV2 = lazyRetry(
  () => import('~/pages/Customer/GreenlineCustomerListV2'),
)
const GreenlineCustomerDetailV2 = lazyRetry(
  () => import('~/pages/Customer/GreenlineCustomerDetailV2'),
)
const FlowhubCustomerList = lazyRetry(
  () => import('~/pages/Customer/FlowhubCustomerList'),
)
const FlowhubCustomerDetail = lazyRetry(
  () => import('~/pages/Customer/FlowhubCustomerDetail'),
)
const LightspeedCustomerList = lazyRetry(
  () => import('~/pages/Customer/LightspeedCustomerList'),
)
const LightspeedCustomerDetail = lazyRetry(
  () => import('~/pages/Customer/LightspeedCustomerDetail'),
)

// Pantry Customer module — single page that branches internally per storeType
// via the CustomerAdapter pattern. Mounts when the Pantry UI is on (see
// `usePantryUI` + RouteWithStore dispatcher). Both LIST and DETAIL are now
// wired to the pantry module; the legacy per-store detail components remain
// mounted for stores on the legacy UI.
// Wrapper supplies the dialog/toast plumbing the pantry library can't reach
// from inside `libs/pantry-features` (no main-app imports). See
// `PantryCustomerListWrapper.tsx` for the Full CSV Export bridge.
const PantryCustomerList = lazyRetry(
  () => import('~/router/PantryCustomerListWrapper'),
)
const PantryCustomerDetail = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.CustomerDetailPage })),
)

const CustomerRouters = [
  {
    path: `${ADMIN_ROUTES.STORE}${CUSTOMER_ROUTES.LIST}`,
    component: CustomerList,
    shopifyComponent: ShopifyCustomerList,
    covaComponentV2: CovaCustomerListV2,
    greenlineComponentV2: GreenlineCustomerListV2,
    flowhubComponentV2: FlowhubCustomerList,
    lightspeedComponentV2: LightspeedCustomerList,
    pantryComponent: PantryCustomerList,
    // Flowhub/Lightspeed customer adapters are not implemented yet.
    posNewUiStoreTypes: [STORE_TYPES.COVA, STORE_TYPES.GREENLINE],
    layout: 'admin',
    exact: true,
    bsTheme: true,
    roles: customerRolesView,
    editRoles: customerRolesEditable,
    routeName: 'Customers List',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${CUSTOMER_ROUTES.SERVICE}`,
    component: CustomerList,
    covaComponent: CovaCustomerList,
    greenlineComponent: GreenlineCustomerList,
    shopifyComponent: ShopifyCustomerList,
    layout: 'admin',
    exact: true,
    roles: customerRolesView,
    editRoles: customerRolesEditable,
    routeName: 'Customers List',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${CUSTOMER_ROUTES.MARKETING}`,
    component: CustomerList,
    covaComponent: CovaCustomerList,
    greenlineComponent: GreenlineCustomerList,
    shopifyComponent: ShopifyCustomerList,
    layout: 'admin',
    exact: true,
    roles: customerRolesView,
    editRoles: customerRolesEditable,
    routeName: 'Customers List',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${CUSTOMER_ROUTES.DETAIL}`,
    component: CustomerDetail,
    shopifyComponent: ShopifyCustomerDetail,
    covaComponentV2: CovaCustomerDetailV2,
    greenlineComponentV2: GreenlineCustomerDetailV2,
    flowhubComponentV2: FlowhubCustomerDetail,
    lightspeedComponentV2: LightspeedCustomerDetail,
    pantryComponent: PantryCustomerDetail,
    // Flowhub/Lightspeed customer adapters are not implemented yet.
    posNewUiStoreTypes: [STORE_TYPES.COVA, STORE_TYPES.GREENLINE],
    layout: 'admin',
    exact: true,
    // roles: customerRolesView,
    // editRoles: customerRolesEditable,
    routeName: 'Customer Detail',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${CUSTOMER_ROUTES.CREATE}`,
    component: CustomerForm,
    covaComponent: CovaCustomerForm,
    layout: 'admin',
    exact: true,
    roles: customerRolesEditable,
    routeName: 'Customer Create',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${CUSTOMER_ROUTES.SEND_EMAIL}`,
    component: SendEmail,
    covaComponent: SendEmail,
    layout: 'admin',
    exact: true,
    roles: customerSendEmail,
    routeName: 'Customer Send Email',
  },
]

export default CustomerRouters
